import React from 'react';

const ImpersonationNotice = () => {
  const name = sessionStorage.getItem('pending-impersonation');

  if (name === null) {
    return null;
  }

  return (
    <div className="alert alert-warning impersonation-notice">
      <p>
        <strong>{`You are starting a pseudo login${name ? ` as ${name}` : ''}.`}</strong>
      </p>
      <ul>
        <li>
          Log in again <strong>here</strong>, <strong>or</strong> open the mobile app and log in —
          whichever you do <strong>first</strong>. You can only use one: if you log in here you
          cannot use the app for this session, and vice versa.
        </li>
        <li>The pseudo login session stays active for <strong>15 minutes</strong>.</li>
        <li>
          This is a <strong>single-use</strong> request and expires in <strong>5 minutes</strong> —
          after that you will need to start the pseudo login again.
        </li>
      </ul>
    </div>
  );
};

export default ImpersonationNotice;
